var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.232422,
    y: 0.116211,
    width: 41.7676,
    height: 41.7676,
    rx: 19.2271,
    fill: "#253F17",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2423 28.5171H28.4296V23.4378C28.4296 19.3987 25.1544 16.1235 21.1153 16.1235C17.0763 16.1235 13.8011 19.3987 13.8011 23.4378V28.5171H12.9884C12.6552 28.5171 12.3789 28.7934 12.3789 29.1266C12.3789 29.4598 12.6552 29.7361 12.9884 29.7361H29.2423C29.5755 29.7361 29.8518 29.4598 29.8518 29.1266C29.8518 28.7934 29.5755 28.5171 29.2423 28.5171Z",
    fill: "#253F17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1154 14.2949C20.7822 14.2949 20.5059 14.0186 20.5059 13.6854V12.8727C20.5059 12.5395 20.7822 12.2632 21.1154 12.2632C21.4486 12.2632 21.7249 12.5395 21.7249 12.8727V13.6854C21.7249 14.0186 21.4486 14.2949 21.1154 14.2949Z",
    fill: "#253F17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.426 15.9203C15.2716 15.9203 15.1172 15.8634 14.9953 15.7415L14.1826 14.9288C13.9469 14.6932 13.9469 14.3031 14.1826 14.0674C14.4183 13.8317 14.8084 13.8317 15.0441 14.0674L15.8568 14.8801C16.0924 15.1158 16.0924 15.5059 15.8568 15.7415C15.7349 15.8634 15.5804 15.9203 15.426 15.9203Z",
    fill: "#253F17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8048 15.9203C26.6503 15.9203 26.4959 15.8634 26.374 15.7415C26.1383 15.5059 26.1383 15.1158 26.374 14.8801L27.1867 14.0674C27.4224 13.8317 27.8125 13.8317 28.0482 14.0674C28.2839 14.3031 28.2839 14.6932 28.0482 14.9288L27.2355 15.7415C27.1136 15.8634 26.9592 15.9203 26.8048 15.9203Z",
    fill: "#253F17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceAlert);
export default __webpack_public_path__ + "static/media/price-alert.a823c333147defb413dea7f72a1961a5.svg";
export { ForwardRef as ReactComponent };